import React from "react";
import {
    PLAN_TYPES,
    PRICE_PERCENTAGE,
} from "src/constants/subscriptionsConstants";
import styles from "./SubscriptionPlanCard.module.scss";

const getOriginalPrice = (price) => {
    const originalPrice = price / 12;
    return originalPrice;
};

const getPlanPrice = (price, planType) => {
    if (planType === PLAN_TYPES.YEAR) {
        return (price / 12) * PRICE_PERCENTAGE;
    }
    return price;
};

const SubscriptionPlanCard = ({
    plan,
    priceId,
    planType,
    handlePlanSelect,
}) => {
    return (
        <div
            onClick={handlePlanSelect}
            className={`${styles.planOption} ${
                priceId === plan.priceId ? styles.selected : ""
            }`}
        >
            <div className={styles.planNameContainer}>
                <h4 className={styles.planName}>{plan.planName}</h4>
                {priceId === plan.priceId ? (
                    <i className="bi bi-check-circle-fill"></i>
                ) : (
                    <i className="bi bi-circle"></i>
                )}
            </div>
            <p className={styles.info}>{plan.planDescription}</p>

            {/* {planType === PLAN_TYPES.YEAR && (
                <p className={styles.originalPrice}>
                    ${getOriginalPrice(plan.price)} / location / month
                </p>
            )} */}
            {/* <p
                className={`${styles.priceInfo} ${
                    planType === PLAN_TYPES.YEAR ? styles.discounted : ""
                }`}
            >
                ${getPlanPrice(plan.price, planType)} / location / month
            </p> */}
            <ul className={styles.perks}>
                {plan.perks.map((perk, i) => (
                    <li key={i} className={styles.perk}>
                        <i className="bi bi-check-circle"></i> {perk}
                    </li>
                ))}
                {/* <i className="bi bi-check-circle"></i> And More... */}
            </ul>
        </div>
    );
};

export default SubscriptionPlanCard;
